import type { ShadowedOperationsMap } from './operationsContext'

export const countShadowedOperations = (map: ShadowedOperationsMap): number =>
  Array.from(map.values())
    .flatMap((block) => Array.from(block.values()))
    .flatMap((layer) => Array.from(layer.values()))
    .reduce((total, datesMap) => total + datesMap.size, 0)
